import Panel from '../../../../common/layout/Panel';
import DataResource from '../../../../common/v4/DataResource';
import { useParams } from 'react-router-dom';

const CarrierSmppAccounts = (props) => {
    const { carrier_id } = useParams();
    const clientData = {
        url: `/admin/carriers/carriers/${carrier_id}/client_smppaccounts`,
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        userfilter: [],
        userFiltersimple: false,
        onclick: 'link',
        link: `/carriers/carriers/${carrier_id}/smppaccounts/client/{id}`,
        metadata: [
            {
                'label': 'id',
                'source': 'id',
                'type': 'primary',
                'editable': false,
                'visible': false,
            },
            {
                'label': 'Username',
                'source': 'username',
                'type': 'text',
                'editable': true,
            },
            {
                'label': 'Use SSL',
                'source': 'use_ssl',
                'type': 'boolean',
                'editable': true,
            },
            {
                'label': 'Rate Profile',
                'source': 'product_id',
                'type': 'select',
                'editable': true,
            },
            {
                'label': 'Bind Mode',
                'source': 'bind_mode',
                'type': 'select',
                'editable': true,
            },
            
            {
                'label': 'Enabled',
                'source': 'status',
                'type': 'boolean',
                'editable': true,
            },
            {
                'label': 'Delete',
                'type': 'delete',
            }
        ]
    }
    return (
        <div className="row">
            <div className="col-md-6">
                <Panel title = "Client SMPP Accounts">
                    <DataResource 
                        addButtonText = "Create Client SMPP Account" 
                        addButtonLink = {`/carriers/carriers/${carrier_id}/smppaccounts/create_client`}
                        data = {clientData} 
                        {...props} 
                    />
                </Panel>
            </div>
        </div>
    )
}

export default CarrierSmppAccounts;
    